import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Account, AuthenticationService, ConnectApiClientService, ErrorHandlerService } from '@aveva/connect-web-core';

@Injectable()
export class AuthenticatedUserAccountResolverService implements Resolve<AccountWithIcon | void> {
  constructor(
    private authenticationService: AuthenticationService,
    private connectApiClient: ConnectApiClientService,
    private errorHandler: ErrorHandlerService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AccountWithIcon | void> {
    return this.authenticationService.getUser()
      .then(user => this.connectApiClient.accountManagement.getAccount(user.account))
      .catch((error) => this.errorHandler.handle(error));
  }
}

export interface AccountWithIcon extends Account {
  icon?: string;
}
